<template>
  <!-- Use content-id="main-content" to mark which element should be controlled by the menu-->
  <!-- Element with id="main-content" gets controlled by menu -->
  <!-- https://ionicframework.com/docs/api/menu -->
  <ion-menu
    type="overlay"
    content-id="main-content"
  >
    <ion-content content-id="main-content">
      <MenuMainElements />
      <MenuRoles />
    </ion-content>
  </ion-menu>
</template>

<script>
import MenuMainElements from '@/components/Layout/MenuMainElements';
import MenuRoles from '@/components/Layout/MenuRoles';


export default {
  name: 'Menu',
  components: { MenuMainElements, MenuRoles },
};
</script>
<style lang="scss" scoped>
    ion-list {/* optional, but it needs when you use gradient as a background color.*/
      background: transparent;
    }
</style>
